module.exports = __webpack_public_path__ + "img/product3.a2a772fa.jpg";